<div class="widget-container" >

  <main>
    <article #fs fullscreen-able [class.is-active]="isFullscreen" style="background-color: white;">
      <div class="header" #heatMapNEW>
        <div>
          <icon-chart 
            [headerConfig]="item.config.widget_header_config"
            [rowDataLength]="data"
            [data]="data"
            [chartName]="'DataGrid'" 
            [pageKey]="pageKey"
            [config]="heatMapNEW" 
            [item]="item" 
            [pageKey]="pageKey"
            [expand]="fs" 
            [fullscreen]="isFullscreen"
            (expendCol)="toggleAll($event)"
            (screenChanges)="toggleFullscreen($event)"></icon-chart>
        </div>

        <app-progress-indefinite *ngIf="isLoading "></app-progress-indefinite>

        <div class="responsive-container" *ngIf="!isLoading && data?.length" [style.gap]="staticLegend ? '10px' : '0px'">
          
          <duc-legend *ngIf="!staticLegend" [config]="config.legend"></duc-legend>
        
          <div class="flex-container" *ngIf="staticLegend">
            <span class="mr-1">Status:</span>
            <duc-legend [config]="config.legend"></duc-legend>
          </div>
        
          <div class="flex-container" *ngIf="staticLegend">
            <span class="mr-1">Indicator:</span>
            <div class="d-flex align-items-center justify-content-between indicator-container">
              <div class="groupof-static-legend" *ngFor="let data of staticLegendItems; let idx = index;trackBy: trackByLegend">
               <div class="mr-2" style="border: 1px solid #fff;height: 13.5px;width: 13.5px;min-width: 13.5px;line-height: 1px;border-radius: 10px;overflow: hidden;display: flex;align-items: center;justify-content: center;">
                <img class="groupof-static-legend-img " [hidden]="!data.marked" [src]="data.url" [alt]="data.name" (click)="interactiveLegend(data, idx)">
                <span class="groupof-static-legend-img " (click)="interactiveLegend(data, idx)" [hidden]="data.marked">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12">
                    <circle cx="6" cy="6" r="5.7" fill="none" stroke="#ddd" stroke-width=".6" />
                  </svg>
                </span>
                </div>
                <div class="groupof-static-text">
                  <span class="label" style="text-transform: uppercase;">{{data.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!isLoading && !data?.length" class="no-data">
          <span class="bg-text">{{error_name ? error_name : 'There is no data for this time period'}}</span>
        </div>

        <div *ngIf="!isLoading && data?.length" class="chart-scroll" [ngClass]="this.item.config['tool_tip_type'].value"
          [ngStyle]="{'height': isFullscreen ? (window.innerHeight - 130) + 'px' : 'auto','overflow':isFullscreen ?'auto':'none','margin': '10px 0'}"
          >

          <!-- [ngStyle]="{'height': isFullscreen ? window.innerHeight + 'px' : 'auto','overflow':'auto'}" -->

          <div class="tree-table" #Statusoverview>
            <duc-tree [config]="config.tree"></duc-tree>
            <!-- touchDblclick: a tap never produces a native dblclick, so on
                 iPad the double-click action below would never run -->
            <duc-status-overview touchDblclick [config]="config.statusOverview" [data]="data" (cellSelected)="toggleModal($event)">
              <!-- TODO use ngComponentOutlet in Angular 16+-->
              <app-status-tooltip-dem #tooltip *ngIf="this.item.config['tool_tip_type'].value === 'dem'"
                [config]="config.tooltip"></app-status-tooltip-dem>
              <app-status-tooltip-dpm #tooltip *ngIf="this.item.config['tool_tip_type'].value === 'dpm'"
                [config]="config.tooltip"></app-status-tooltip-dpm>
            </duc-status-overview>
          </div>

        </div>
      </div>

    </article>
  </main>
</div>